import { render, staticRenderFns } from "./TStabilityDashboard.vue?vue&type=template&id=6be15d82&"
import script from "./TStabilityDashboard.vue?vue&type=script&lang=js&"
export * from "./TStabilityDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardTitle,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6be15d82')) {
      api.createRecord('6be15d82', component.options)
    } else {
      api.reload('6be15d82', component.options)
    }
    module.hot.accept("./TStabilityDashboard.vue?vue&type=template&id=6be15d82&", function () {
      api.rerender('6be15d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/TStabilityDashboard.vue"
export default component.exports